<div
  *renderingPermissionDirective="[
    'DeviceCommandWriter',
    'DeviceCommandReader',
    'DeviceCommandAdmin',
  ]"
  class="device-command">
  <div class="device-command__content">
    <div class="device-command__grid-title">
      <span class="lx-section-title">Commands</span>
    </div>
    <div class="device-command__actions">
      <div
        *renderingPermissionDirective="[
          'DeviceCommandWriter',
          'DeviceCommandAdmin',
        ]"
        class="device-command__actions__button-container">
        <button
          class="lx-btn-small lx-btn-primary"
          id="newRequest"
          (click)="openModal()">
          Issue Commands
        </button>
      </div>
      <div class="device-command__actions__refresh">
        <div class="device-command__actions__refresh__button">
          <button
            class="lx-btn-small lx-btn-text"
            (click)="onRefresh()">
            <i class="lx-icon lx-reset"></i>
            Refresh
          </button>
        </div>
      </div>
    </div>
    <div class="device-command__data">
      <ag-grid-angular
        class="ag-theme-alpine ag-grid-sticky-header"
        domLayout="autoHeight"
        style="width: 100%; height: 100%"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [enableCellTextSelection]="true"
        [ensureDomOrder]="true"
        [suppressRowHoverHighlight]="true"
        (gridReady)="onGridReady($event)"></ag-grid-angular>
    </div>
    <div class="device-command__pagination_container">
      <div class="device-command__pagination_container__count-select">
        <label>Show</label>
        <dcc-dropdown
          [pageSizes]="pageSizes"
          [selectedSize]="pageSize"
          (changedPageSize)="onPageSizeSelected($event)"></dcc-dropdown>
        <label>Items</label>
      </div>
      <div class="device-command__pagination_container__page-select">
        <paginator
          [currentPageNumber]="currentPage"
          [endOfSet]="endOfSet"
          [pageNumbers]="paginationTokenMap.size"
          (selectedPage)="onPageSelection($event)"></paginator>
      </div>
    </div>
  </div>
</div>
